<template>
  <header class="iBusiness-header clearfix" :class="isChatPage ? 'header_bg' : ''">
    <div class="header-left">
      <div class="notice">
        <svg class="icon" aria-hidden="true" :class="isChatPage ? 'icon_bg' : ''">
          <use xlink:href="#iconheadicon-tongzhi" />
        </svg>
        <!-- 您好，云客服企业用户abc的有效期
        <span class="text-danger">365</span> 天，有疑问联系电话
        <span class="text-info">400-800-2222</span>-->
      </div>
    </div>
    <div class="header-right">
      <ul>
        <!-- <li class="header-right-item">
          <div class="pst">
            <a href>
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#iconheadicon-xiaoxi" />
              </svg>
              消息
              <span class="badge">99</span>
            </a>
          </div>
        </li>
        <li class="header-right-item">
          <a href>
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#iconheadicon-help" />
            </svg>
            帮助
          </a>
        </li>-->
        <!-- <li class="header-right-item">
          <a href="#" @click="jumpToWorkbenchWindow" v-if="wbJumpAllow === 'true'">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#iconheadicon-zuoxi" />
            </svg>
            坐席工作台
          </a>
        </li> -->
        <li class="header-right-item" v-show="this.$route.path === '/chat'">
          <div class="icon-state-wrapper">
            <span class="icon-state" :class="'icon-state-'+current_status" @click="show_status_box = !show_status_box"></span>
          </div>
          <div class="tips-layer" v-show="show_status_box">
            <ul>
              <li v-for="(item, index) in status" :key="index" @click="changeStatus(item)"><span class="icon-state" :class="'icon-state-' + item.value"></span>{{ item.tag }}</li>
            </ul>
          </div>
        </li>
        <li class="header-right-item">
          <el-dropdown>
            <a href="javascript:void(0);" :class="isChatPage ? 'icon_bg' : ''">
              <svg class="icon icon-user" aria-hidden="true" :class="isChatPage ? 'icon_bg' : ''">
                <use xlink:href="#iconheadicon-user" />
              </svg>
              <span style="font-size:15px;margin-left:5px;">{{ $t(userName) }}</span>
            </a>
            <el-dropdown-menu slot="dropdown" class="menu">
              <!-- <el-dropdown-item class="item">
                <svg class="icon icon-user svg-padding" aria-hidden="true">
                  <use xlink:href="#iconmenu-gerenshezhi" />
                </svg>
                个人信息设置
              </el-dropdown-item> -->
              <el-dropdown-item class="item" @click.native.prevent="logout">
                <svg class="icon icon-user svg-padding" aria-hidden="true">
                  <use xlink:href="#iconjieshuduihua" />
                </svg>
                退出登录
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </li>
      </ul>
    </div>
  </header>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  name: 'TopBar',
  props: {},
  computed: {
    isChatPage() {
      return this.$route.path === '/chat'
    },
    current_status() {
      let status = null
      if (this.$store.state.user.status === '') {
        status = localStorage.getItem('WORK-STATUS')
      } else {
        status = this.$store.state.user.status
      }
      return !status ? 'busy' : status
    },
    ...mapState([
      'user'
    ])
  },
  data() {
    return {
      tokenScanTask: null,
      wbUrl: window.$envUtils('VUE_APP_WB_URL') + (process.env.NODE_ENV === 'development' ? '?token=' + this.$store.state.user.Authorization + '&tenantId=' + localStorage.getItem('X-TENANT-ID') : ''),
      wbJumpAllow: this.$store.state.user.wbJumpAllow,
      userName: this.$store.state.user.loginUser.userName,
      WorkbenchWindows: null, // 坐席工作台窗口对象
      show_status_box: false,
      status: [
        {
          tag: '在线',
          code: 1,
          value: 'online'
        }, {
          tag: '忙碌',
          code: 2,
          value: 'busy'
        }
        // todo 暂无暂离状态（后续结合质检加入）
        // , {
        //   tag: '暂离',
        //   code: 3,
        //   value: 'offline'
        // }
      ]
    }
  },
  mounted() {
    var that = this
    // 设置一个定时扫描任务,每隔2秒扫描一次,如果bp/wb端登出了,则wb/bp端也立即跳转到登录页
    that.tokenScanTask = setInterval(function() {
      const token = localStorage.getItem('Authorization')
      if (!token) {
        // 清除定时任务
        clearInterval(that.tokenScanTask)
        // 执行与logout方法相同的逻辑(直接拷贝)
        that.$store.commit('user/resetState')
        that.$store.commit('role/resetState')
        // localStorage.clear()
        that.$router.push('/login')
      }
    }, 2000)
  },

  methods: {
    ...mapActions('user', ['handleLogOut']),
    logout() {
      window.opener = null
      window.open('', '_self')
      window.close()

      // this.handleLogOut()
      //   .then(res => {
      //     if (res.code === 2000) {
      //       // 清除vuex
      //       this.$store.commit('user/resetState')
      //       this.$store.commit('role/resetState')
      //       localStorage.clear()
      //       this.$router.push('/login')
      //     }
      //   })
      //   .catch(() => { })
    },
    // 跳转到坐席工作台
    jumpToWorkbenchWindow() {
      // 判断wb是否已经打开了，坐席工作台页面onload时候会在localStorage中设置键，在unload的时候会移除这个键
      if (localStorage.getItem('wbHasOpened')) {
        // 有键说明已经打开了坐席工作台
        if (this.WorkbenchWindow) {
          // 子window对象存在则聚焦
          this.WorkbenchWindow.focus()
        } else {
          // 子window对象不存在则弹出提示(但不聚焦)
          alert('坐席工作台已经存在，请不要重复打开！')
        }
      } else {
        // 无键说明还未打开过坐席工作台
        this.WorkbenchWindow = window.open(this.wbUrl, '_blank') // 打开新窗口
      }
    },
    changeStatus(item) {
      const oldStatus = this.$store.getters.workStatus
      // 【防御机制】如果状态值没有真的改变,则不发送请求，直接返回
      if (item.value === oldStatus) {
        return
      }
      this.$store.commit('user/setStatus', item.value)
      this.show_status_box = false
      this.$http.put(window.$envUtils('VUE_APP_WB_SERVICE') + '/infinite/currentSession/changeStatus', {
        params: {
          status: item.code,
          token: localStorage.getItem('Authorization')
        }
      })
    }
  }
}
</script>

<style scoped>
.menu {
  padding: 6px 0;
  border-radius: 4px;
}
.item {
  font-size: 12px;
  height: 30px;
  line-height: 30px;
  padding: 0 10px;
}
.svg-padding {
  margin-right: 6px;
}
</style>
<style lang="scss" scoped>
.header_bg{
  background-color: #597df0;
  border-bottom: 1px solid #e1e3e6;
  color: #FFFFFF;
}
.icon_bg{
  color: #FFFFFF !important;
  &:hover{
    color:#464540 !important;
    .icon {
      color:#464540;
    }
  }
}
</style>
